export default __webpack_public_path__ + "static/media/RB.31192a55.png";